import BaseApi from './BaseApi'

class SubscriptionApi extends BaseApi {
  subscribe (subscription) {
    return this.post('subscriptions/subscribe', subscription)
  }

  updatePaymentMethod (stripeToken) {
    return this.post('subscriptions/updateCard', stripeToken)
  }

  cancel () {
    return this.post('subscriptions/cancel')
  }

  resume () {
    return this.post('subscriptions/resume')
  }

  getPaymentPlans () {
    return this.get('subscriptions/plans')
  }
  changePaymentPlan (plan) {
    return this.post('subscriptions/changePlan', { plan })
  }

  saveBillingInfo (info, userId) {
    return this.post(`user/${userId}/billingInfo/`, info)
  }

  createIntent () {
    return this.post(`subscriptions/createIntent`)
  }
}

export default new SubscriptionApi()
